<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.48667 3.51855H2.35071V4.67522H9.48667V3.51855Z"
      fill="#B55703"
    />
    <path
      d="M12.9818 12.2152C13.535 11.2381 13.3746 9.99295 12.5699 9.18918C12.0939 8.71316 11.461 8.45044 10.7855 8.45044C10.1101 8.45044 9.47624 8.71316 9.00022 9.18918C8.5242 9.6652 8.26147 10.2982 8.26147 10.9745C8.26147 11.6482 8.5242 12.282 9.00022 12.7598C9.47624 13.2341 10.1092 13.4968 10.7838 13.4968C11.2234 13.4968 11.6491 13.3849 12.0271 13.1716L14.8555 16L15.8102 15.0445L12.9818 12.2152ZM11.8477 12.0358C11.2823 12.6011 10.2904 12.6011 9.72508 12.0358C9.13981 11.4496 9.13981 10.4985 9.72508 9.91232C10.0077 9.62965 10.3858 9.47358 10.7872 9.47358C11.1887 9.47358 11.565 9.62965 11.8485 9.91232C12.1321 10.195 12.2881 10.573 12.2881 10.9745C12.2881 11.3759 12.1312 11.7522 11.8477 12.0358Z"
      fill="#B55703"
    />
    <path
      d="M11.5598 14.1332H1.6102C1.45239 14.1332 1.32493 14.0049 1.32493 13.8488V1.42026C1.32493 1.26245 1.45239 1.13499 1.6102 1.13499H11.5598C11.7176 1.13499 11.8442 1.26245 11.8442 1.42026V7.76026C12.2561 7.85043 12.6402 8.02645 12.9801 8.2779V1.42026C12.9801 0.637295 12.3436 0 11.5598 0H1.6102C0.827236 0 0.189941 0.637295 0.189941 1.42026V13.8488C0.189941 14.6309 0.827236 15.2682 1.6102 15.2682H11.5598C12.1537 15.2682 12.4347 15.1277 12.6462 14.6092L12.1312 14.0942C11.9413 14.174 11.6413 14.1332 11.5598 14.1332Z"
      fill="#B55703"
    />
    <path
      d="M9.48667 6.77869H2.35071V7.93536H9.48667V6.77869Z"
      fill="#B55703"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
